import { ACT_STS_CHANGE } from "./ActionTypes";
import StatsService from "../provider/statistics/StatsService";
import {loading} from "./AppActions"


/*** ACTIONS STATS ******/
export function actionOrdersStats(dates, period, orderTypes, paymentMethod, succesCallback, errorCallback) {
  return (dispatch, getStore) => {
    // loading(true)(dispatch, getStore)
    const restoId = getStore().evt.restaurant.id
    StatsService.ordersStats(getStore().app.app, restoId, dates, period, orderTypes, paymentMethod).then((response) => {
        dispatch({
            type:ACT_STS_CHANGE,
            props: {ordStats:response}
        })
        succesCallback&&succesCallback(response)
    }).catch(errorCallback)
    // .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionMenuStats(dates, period, unit, top, orderTypes, paymentMethod, succesCallback, errorCallback) {
  return (dispatch, getStore) => {
  //   loading(true)(dispatch, getStore)
    const restoId = getStore().evt.restaurant.id
    StatsService.menuStats(getStore().app.app, restoId, dates, period, unit, top, orderTypes, paymentMethod).then((response) => {
        dispatch({
            type:ACT_STS_CHANGE,
            props: {mnuStats:response}
        })
        succesCallback&&succesCallback()
    }).catch(errorCallback)
  //   .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionTopClientStats(dates, period, orderTypes, paymentMethod, succesCallback, errorCallback) {
  return (dispatch, getStore) => {
  //   loading(true)(dispatch, getStore)
    const restoId = getStore().evt.restaurant.id
    StatsService.topClientStats(getStore().app.app, restoId, dates, period, orderTypes, paymentMethod).then((response) => {
        dispatch({
            type:ACT_STS_CHANGE,
            props: {topClientStats:response}
        })
        succesCallback&&succesCallback(response)
    }).catch(errorCallback)
  //   .finally(()=>{loading(false)(dispatch, getStore)})
  };
}


export function actionLiqResumeStats(dates, month, succesCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore)
    const restoId = getStore().evt.restaurant.id
    StatsService.liqStats(getStore().app.app, restoId, dates, month, false).then((response) => {
        if(!month){
          dispatch({
              type:ACT_STS_CHANGE,
              props: {liqResume:response}
          })
        }
        succesCallback&&succesCallback(response)
    }).catch(errorCallback)
    .finally(()=>{loading(false)(dispatch, getStore)})
  };
}

export function actionLiqDetailStats(dates,  succesCallback, errorCallback) {
  return (dispatch, getStore) => {
    loading(true)(dispatch, getStore)
    const restoId = getStore().evt.restaurant.id
    StatsService.liqStats(getStore().app.app, restoId, dates, null, true).then((response) => {
        succesCallback&&succesCallback(response)
    }).catch(errorCallback)
    .finally(()=>{loading(false)(dispatch, getStore)})
  };
}


// WEBPACK FOOTER //
// ./src/actions/StatsActions.js